import React, { Fragment, useState } from "react";
import { useOfflineInvoice } from "../../../../hooks/useCrm";
import { OfflineInvoiceStyle } from "./OfflineInvoiceStyle";
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import Typogaphy from "../../../../components/Typography/Typography";
import Button from "../../../../components/Button/Button";
import { DeleteActionModal } from "../../../../components/Dialog/DeleteActionModal";
import { IoMdTrash } from "react-icons/io";
import Converter from "persian-date-converter";
import {
  AiFillTag,
  AiOutlineDollarCircle,
  AiOutlineEdit,
  AiOutlineInteraction,
} from "react-icons/ai";
import { BsFillPersonCheckFill } from "react-icons/bs";
import { TagSelectionOfflineInvoiceModal } from "../../../../components/Dialog/TagSelectionOfflineInvoiceModal";
import { ResponsibleChangeOfflineInvoiceModal } from "../../../../components/Dialog/ResponsibleChangeOfflineInvoiceModal";
import { ChangeToUnsuccessfulModal } from "../../../../components/Dialog/ChangeToUnsuccessfulModal";
import { NavLink } from "../../../../components/Navbar/navbarStyle";
import { RenderTooltip } from "../../../../components/Tooltip/Tooltip";
import { EditOfflineInvoiceModal } from "../../../../components/Dialog/EditOfflineInvoiceModal";
const initvalue = {
  DeleteFactor: false,
  TagSelection: false,
  ResponsibleChange: false,
  ChangeToUnsuccessful: false,
  EditInvoice: false,
};
export const OfflineInvoice = ({ userdata, tags }) => {
  const [show, setShow] = useState(initvalue);
  const [factorId, setFactorId] = useState();
  const [factor, setFactor] = useState();
  const [factorTag, setFactorTag] = useState();
  const [factorResponsible, setFactorResponsible] = useState();
  const { data: OfflineInvoice } = useOfflineInvoice({
    IdUserFile: userdata?.sales_opportunities[0]?.IdUser,
  });
  const Factors = OfflineInvoice?.data;

  const _date = new Converter();
  const listMarket = Factors?.MarketerUser?.map((market) => market);
  return (
    <OfflineInvoiceStyle>
      {Factors?.order_offlines?.map((factor, index) => {
        const createDate = factor.created_at;
        var dateWrapper = _date.convert(createDate, "fa");
        const color = tags?.filter((tag) =>
          tag?.NameTag === factor?.FactorTag ? tag?.ColorTag : ""
        );
        return (
          <div className="invoice row" key={index}>
            <div className="status col-lg-1 col-md-1 col-1 p-0">
              {/* <IoCheckmarkDoneOutline
                className="icon"
                // color={tags[index]?.ColorTag}
                color={
                  factor?.FactorTag === tags[index]?.NameTag
                    ? tags[index].ColorTag
                    : ""
                }
              /> */}

              <IoCheckmarkDoneOutline
                className="icon"
                // color={tags[index]?.ColorTag}
                color={color[0]?.ColorTag}
              />
            </div>
            <div className="main-content col-lg-5 col-md-6 col-8">
              <Typogaphy size="14px">
                مسئول:{" "}
                {Factors?.MarketerUser.map((item, index) => (
                  <Fragment key={index}>
                    {item.IdOrderOffline === factor.IdOrderOffline
                      ? item.FirstName + " " + item.LastName
                      : null}
                  </Fragment>
                ))}
              </Typogaphy>
              <Typogaphy size="14px">تاریخ: {dateWrapper}</Typogaphy>
              <Typogaphy size="14px">
                ثبت شده توسط: {factor.FirstName + " " + factor.LastName}
              </Typogaphy>
            </div>
            <div className="price col-lg-2 col-md-5 col-3">
              <Typogaphy>{factor.DepositAll.toLocaleString()} تومان</Typogaphy>
            </div>
            <div className="actions col-lg-4 col-md-12 justify-content-center mt-lg-0 mt-3 justify-content-lg-left justify">
              <RenderTooltip title="فاکتور سریع">
                <Button bgColor="#009ef7">
                  <NavLink
                    to=""
                    bgColor="transparent !important"
                    className="p-0"
                  >
                    <AiOutlineDollarCircle color={"#fff"} />
                  </NavLink>
                </Button>
              </RenderTooltip>
              <RenderTooltip title="تغییر برچسب">
                <Button
                  onclick={() => {
                    setShow({ ...initvalue, TagSelection: true });
                    setFactorId(factor.IdOrderOffline);
                    setFactorTag(factor.FactorTag);
                  }}
                  bgColor="#50cd89"
                >
                  <AiFillTag color={"#fff"} />
                </Button>
              </RenderTooltip>
              {/* <RenderTooltip title="حذف فاکتور">
                <Button
                  onclick={() => {
                    setShow({ ...initvalue, DeleteFactor: true });
                    setFactorId(factor.IdOrderOffline);
                  }}
                  bgColor="#f1416c"
                >
                  <IoMdTrash color={"#fff"} />
                </Button>
              </RenderTooltip> */}
              <RenderTooltip title="تغییر مسئول">
                <Button
                  onclick={() => {
                    setShow({ ...initvalue, ResponsibleChange: true });
                    setFactorId(factor.IdOrderOffline);
                    setFactorResponsible(
                      listMarket[index]?.FirstName +
                        " " +
                        listMarket[index]?.LastName
                    );
                  }}
                  bgColor="#009ef7"
                >
                  <BsFillPersonCheckFill color={"#fff"} />
                </Button>
              </RenderTooltip>
              <RenderTooltip title="تبدیل به ناموفق">
                <Button
                  onclick={() => {
                    setShow({ ...initvalue, ChangeToUnsuccessful: true });
                    setFactorId(factor.IdOrderOffline);
                  }}
                  bgColor="#50cd89"
                >
                  <AiOutlineInteraction color={"#fff"} />
                </Button>
              </RenderTooltip>
              <RenderTooltip title="ویرایش فاکتور">
                <Button
                  onclick={() => {
                    setShow({ ...initvalue, EditInvoice: true });
                    setFactor(factor);
                  }}
                  bgColor="#f1416c"
                >
                  <AiOutlineEdit color={"#fff"} />
                </Button>
              </RenderTooltip>
            </div>
          </div>
        );
      })}
      <DeleteActionModal
        handleClose={() => setShow({ ...initvalue, DeleteFactor: false })}
        show={show.DeleteFactor}
        factorId={factorId}
      />
      <TagSelectionOfflineInvoiceModal
        handleClose={() => setShow({ ...initvalue, TagSelection: false })}
        show={show.TagSelection}
        factorId={factorId}
        factorTag={factorTag}
      />

      <ResponsibleChangeOfflineInvoiceModal
        handleClose={() => setShow({ ...initvalue, ResponsibleChange: false })}
        show={show.ResponsibleChange}
        factorId={factorId}
        factorResponsible={factorResponsible}
      />
      <EditOfflineInvoiceModal
        handleClose={() => setShow({ ...initvalue, EditInvoice: false })}
        show={show.EditInvoice}
        factor={factor}
      />
      <ChangeToUnsuccessfulModal
        handleClose={() =>
          setShow({ ...initvalue, ChangeToUnsuccessful: false })
        }
        show={show.ChangeToUnsuccessful}
        factorId={factorId}
      />
    </OfflineInvoiceStyle>
  );
};
